import { css } from '@emotion/react';
import { CommonStyled } from './CommonStyled';

/*
 * File   : globalStyle.tsx
 * SUMMARY:
 * 01) GLOBAL
 * 02) SELECTER
 * 03)
 */
export const GlobalStyled = css`
  /* ************************************** *
   * PC VER
   * ************************************** */

  /* @font-face {
    font-family: 'Roboto';
    src: url('https://fonts.googleapis.com/css?family=Roboto:400,300,100,500,700&display=swap');
  }

  @font-face {
    font-family: 'Noto Sans JP';
    src: url('https://fonts.googleapis.com/css?family=Noto+Sans+JP:400,300,100,500,600,700');
  } */

  ${CommonStyled}

  /* GLOBAL */
  * {
    padding: 0;
    margin: 0;
    text-decoration: none;
    letter-spacing: -0.015em;
  }

  *,
  *:before,
  *:after {
    box-sizing: border-box;
  }

  html {
    height: 100%;
    font-size: 20px !important;
    font-family: 'Noto Sans JP' !important;
    -webkit-font-smoothing: subpixel-antialiased;
    -ms-font-smoothing: subpixel-antialiased;
  }

  body {
    font-size: 1rem !important;
    font-family: 'Noto Sans JP';
    margin: 0;
    padding: 0;
    -webkit-touch-callout: none;
    -webkit-touch-select: none;
    -ms-user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    -webkit-text-size-adjust: none;
    -moz-text-size-adjust: none;
    -ms-text-size-adjust: none;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    -o-user-select: none;
    user-select: none;
    line-height: 1.05rem !important;

    &.ReactModal__Body--open {
      width: 100%;
      overflow: hidden;
    }
  }

  html,
  body,
  iframe,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: 0px;
    padding: 0px;
    border: 0px;
    font: inherit;
    vertical-align: baseline;
    font-weight: normal;
    -webkit-font-smoothing: subpixel-antialiased;
    -webkit-text-size-adjust: 100%;
    -ms-text-size-adjust: 100%;
    -webkit-font-smoothing: subpixel-antialiased !important;
    font-smooth: subpixel-antialiased;
    color: #666;
    line-height: 1.3em;
  }

  ul {
    margin: 0px;
    padding: 0px;
    list-style: none;
  }

  li,
  p {
    margin: 0px;
    padding: 0px;
    list-style: none;
  }

  p {
    color: #666;
  }

  a {
    text-decoration: none;
    color: #666;
  }

  img {
    max-width: 100%;
    display: block;
    -ms-interpolation-mode: bicubic;
  }

  input,
  button,
  textarea,
  select {
    font-family: 'Noto Sans JP';
    outline: none !important;
    border: none;
    -webkit-appearance: none;
    border-radius: 0;
    cursor: pointer;
    background: transparent;
  }

  input {
    cursor: text;
  }

  input[type='radio'] {
    appearance: none;
    -webkit-appearance: none;
    -ms-appearance: none;
    display: none;
  }

  button {
    outline: none !important;
    border: none;
    padding: 0;
    margin: 0;
  }

  picture,
  source {
    line-height: 0;
    display: block;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    border-spacing: 0;
    padding: 0;
  }

  table th {
    color: #333;
  }

  table th,
  td {
    border-bottom: 1px solid #ddd;
  }

  caption {
    visibility: hidden;
    overflow: hidden;
    width: 1px;
    height: 1px;
    font-size: 0;
    line-height: 0;
  }

  article,
  aside,
  figure,
  footer,
  header,
  hgroup,
  menu,
  nav,
  section {
    display: block;
  }

  fieldset {
    border: 0;
    padding: 0;
    margin: 0;
    outline: none;
  }

  content h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-weight: 600;
  }

  .clearfix:before,
  .clearfix:after {
    content: '';
    visibility: hidden;
    display: block;
    height: 0;
    clear: both;
  }

  .clearfix {
    zoom: 1;
  }

  /* ************************************** *
   * TABLET PC VER
   * ************************************** */

  @media (min-width: 768px) and (max-width: 1023px) {
    html {
      font-size: 18px !important;
    }
    body {
      font-size: 1rem !important;
      margin: 0;
      padding: 0;
    }
  }

  /* ************************************** *
   * MOBILE VER
   * ************************************** */

  @media (min-width: 0) and (max-width: 767px) {
    html {
      font-size: 16px !important;
    }
    body {
      font-size: 1rem !important;
      margin: 0;
      padding: 0;
    }
  }
`;
